import { COLORS } from "../shared/constants";
import { IconLogout } from "../shared/icons";

export default // ─── Header ──────────────────────────────────────────────────
function Header({ user, onLogout, onNavigate }) {
  return (
    <div style={{
      background: COLORS.headerBg,
      color: COLORS.headerText,
      padding: "0 24px",
      height: "56px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      position: "sticky",
      top: 0,
      zIndex: 100,
    }}>
      <div
        style={{ display: "flex", alignItems: "center", gap: "12px", cursor: "pointer" }}
        onClick={() => onNavigate("HOME")}
      >
        <span style={{ fontSize: "18px", fontWeight: "700", letterSpacing: "0.3px" }}>Fox TMS</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          background: "rgba(255,255,255,0.12)",
          padding: "6px 12px",
          borderRadius: "8px",
        }}>
          <span style={{ fontSize: "13px", fontWeight: "500" }}>{user.first_name} {user.last_name}</span>
          <span style={{
            fontSize: "10px",
            background: user.role === "MD" ? COLORS.accent : "rgba(255,255,255,0.2)",
            padding: "2px 6px",
            borderRadius: "4px",
            fontWeight: "600",
          }}>{user.role}</span>
        </div>
        <button
          onClick={onLogout}
          style={{
            background: "none",
            border: "none",
            color: "rgba(255,255,255,0.7)",
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
          }}
          title="Log out"
        >
          <IconLogout />
        </button>
      </div>
    </div>
  );
}

// ─── Home Screen ─────────────────────────────────────────────

